<template>
    <div class="il-signup-adapter" :style="adapterStyle">
      <enter-name v-if="enterNameStep" :next-step="nextPage" :signup-text="signupText" :extra-cta-props="ctaProps" :with-login-link="false" />
      <enter-email v-else-if="enterEmailStep" :next-step="nextPage" :signup-text="signupText" :extra-cta-props="ctaProps" />
      <enter-phone-number v-else-if="enterPhoneNumberStep" :next-step="nextPage" :signup-text="signupText" :extra-cta-props="ctaProps" />
      <signup-enter-code v-else :next="onEnterCode" :signup-text="signupText" />
  </div>
</template>

<script>
import GenerateCodeMixin from '@/pages/responsive-pages/non-authenticated/wine-and-dine/signup/steps/GenerateCodeMixin';
import { mapMutations, mapState, mapGetters } from 'vuex';
import Segment from '@/Segment';
import DDLogs from '@/DDLogs';
import LoginApi from '@/api/LoginApi';
import router, { externalLinkRedirect } from '@/router';
import auth0 from '@/utils/auth0';
import SignupEnterCode from '@/pages/responsive-pages/non-authenticated/wine-and-dine/signup/steps/SignupEnterCode';
import EnterName from '@/pages/responsive-pages/non-authenticated/wine-and-dine/signup-v3/steps/EnterName';
import EnterEmail from '@/pages/responsive-pages/non-authenticated/wine-and-dine/signup-v3/steps/EnterEmail';
import EnterPhoneNumber from '@/pages/responsive-pages/non-authenticated/wine-and-dine/signup-v3/steps/EnterPhoneNumber';

const STEPS = {
  EnterNameStep: 0,
  EnterEmailStep: 1,
  EnterPhoneNumberStep: 2,
  EnterCodeStep: 3,
};

export default {
  name: 'IlSignupStoryLibAdapter',
  mixins: [GenerateCodeMixin],
  components: {
    EnterName,
    EnterEmail,
    EnterPhoneNumber,
    SignupEnterCode,
  },
  props: {
    widget: {
      type: Object,
      required: true,
    },
    analyticsPrefix: {
      type: String,
      default: '',
    },
    extraParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      currentStep: STEPS.EnterNameStep,
    };
  },
  async created() {
    this.setProductName('oneTimeScrapeIl');
    this.setProduct('oneTimeScrapeIl');
    this.setSegmentEventPrefix('OtsSignup');
  },
  computed: {
    ...mapState('signup', ['segmentEventPrefix']),
    ...mapState('onboardingState', ['product']),
    ...mapGetters('onboardingState', ['isOTSIL']),
    enterNameStep() {
      return this.currentStep === STEPS.EnterNameStep;
    },
    enterEmailStep() {
      return this.currentStep === STEPS.EnterEmailStep;
    },
    enterPhoneNumberStep() {
      return this.currentStep === STEPS.EnterPhoneNumberStep;
    },
    signupText() {
      return '';
    },
    ctaProps() {
      return {
        backgroundColor: this.widget.backgroundColor,
        pageBackgroundColor: this.widget.backgroundColor,
        // TODO: add support for button props for each step
        // buttonProps: {
        //   title: this.widget.enterNameButtonText || 'קדימה',
        // },
      };
    },
    adapterStyle() {
      return {
        backgroundColor: this.widget.backgroundColor,
        width: '100%',
        height: '100%',
        borderRadius: `${this.widget.borderRadius || 0}px`,
      };
    },
  },
  methods: {
    ...mapMutations('signup', ['resetError', 'setSegmentEventPrefix', 'setProductName']),
    ...mapMutations('onboardingState', ['setProduct']),
    nextPage() {
      if (this.currentStep === 3) {
        return;
      }
      this.currentStep += 1;
    },
    async generateCodeAndProceed(firstName, lastName, phoneNumber, email, enableMarketingEmails) {
      await this.generateCodeForSignup(firstName, lastName, phoneNumber, email, enableMarketingEmails);
      this.currentStep = STEPS.EnterCodeStep;
    },
    async onEnterCode() {
      const is2faRequired = await LoginApi.is2faRequired();
      if (is2faRequired) {
        Segment.trackUserGot(`${this.segmentEventPrefix}2faRedirectToAuth0Signup`);
        DDLogs.log('[ots] Customer redirect to Auth0Signup flow');
        const encodedRedirectTo = auth0.getEncodedRedirectTo({ path: '/ots/connect', query: this.$route.query });
        externalLinkRedirect(`/api/partial-auth/login-with-auth0/new?redirectTo=${encodedRedirectTo}`);
      } else {
        await router.replace({ path: '/ots/connect', query: this.$route.query });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/mixins.scss';

.il-signup-adapter {
  display: flex;
  flex-direction: column;
  position: relative;
}

.full-height {
  height: 100%;
}
</style>
